module.exports = __webpack_public_path__ + "static/404-bg-mob-5f948196b91c94e8ccc9aa130e6db21b.svg";